import { render, staticRenderFns } from "./VueEmailMessageTemplates.vue?vue&type=template&id=44b04abe"
import script from "./VueEmailMessageTemplates.vue?vue&type=script&lang=js"
export * from "./VueEmailMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b04abe')) {
      api.createRecord('44b04abe', component.options)
    } else {
      api.reload('44b04abe', component.options)
    }
    module.hot.accept("./VueEmailMessageTemplates.vue?vue&type=template&id=44b04abe", function () {
      api.rerender('44b04abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueEmail/VueEmailMessageTemplates.vue"
export default component.exports